export type ApplicationType = 'SUPER_ADMIN' | 'ADMIN' | 'PORTAL';
export type UserStatus = 'ACTIVE' | 'INACTIVE';
export type AuthorityType = 'ROLE_SUPER_ADMIN' | 'ROLE_ADMIN' | 'ROLE_USER';
export type QuestionType = 'TEXT' | 'NUMERIC' | 'OPTION';

export const languageTypes = ['es', 'en'] as const;
export type LanguageType = (typeof languageTypes)[number];
